<template>
  <div id="tester">
    <div class="headerWrap">
      <calendar></calendar>
      <machine-selection v-bind:fireSettings="fireSettings"></machine-selection>
    </div>
    <booking-loader class="tester2" v-bind:firebooking="fireBooking" v-bind:selectedDay="selectedDateRecived" v-bind:machineSelection="machineSelection"></booking-loader>
    <br />
    <div class="addButton">
      <!-- <icon name="plus" scale="2.4"></icon> -->
      <div v-on:click="addBooking"><icon class="iconClass" name="plus" scale="2"></icon></div>
    </div>
    <transition name="fade">
      <reservation-modal
      v-if="showReservationModal"
      v-bind:computedSelectionDay="computedSelectionDay"
      v-bind:selectedDateRecived="selectedDateRecived"
      v-bind:machineSelection="machineSelection"
      v-bind:firebooking="fireBooking"
      v-bind:fireSettings="fireSettings">
      </reservation-modal>
    </transition>
    <transition name="fade">
      <delete-booking-modal
      v-if="showDeleteBookingModal"
      v-bind:deleteBookingObject="deleteBookingObject"
      v-bind:selectedDay="selectedDateRecived">
      </delete-booking-modal>
    </transition>
    <transition name="fade">
      <info-modal v-if="showModal" @close="closeModalSetCookie">
        <div slot="body">Addressændring</div>
        <div slot="smalltext">Fra d. 18 Juni vil webadressen skifte fra vaskerum.dk til <b>app.vaskerum.dk</b> så husk at lave din genvej om, hvis du har lavet en.<br /><br />
          app.vaskerum.dk virker allerede fra idag.<br />
        </div>
      </info-modal>
    </transition>
  </div>
</template>

<script>
import { app } from '@/firebase'
import { db } from '@/firebase'
import bus from '@/bus.js'
import Calendar from '@/components/calendar.vue'
import machineSelection from '@/components/machineSelection.vue'
import bookingLoader from '@/components/bookingLoader.vue'
import reservationModal from '@/components/reservationModal.vue'
import deleteBookingModal from '@/components/deleteBookingModal.vue'
import infoModal from '@/components/infoModal.vue'

export default {
  data () {
    return {
      machineSelection: 'wash',
      computedSelectionDay: {},
      selectedDateRecived: {},
      bookingInterval: {startHour: 7, startMinutes: 15, endHour: 10, endMinutes: 0},
      bookingTime: {startHour: 7, startMinutes: 15, endHour: 10, endMinutes: 0},
      showReservationModal: false,
      showDeleteBookingModal: false,
      deleteBookingObject: {},
      showModal: false,
      modalInfoText: 'Fra d. 18 Juni vil webadressen være app.vaskerum.dk så husk at lave din genvej om, hvis du har lavet en!'
    }
  },
  firebase () {
  return {
  fireBooking: {
    source: db.ref('laundryrooms/' + this.$laundryRoom + '/bookings').orderByChild('start'),
    readyCallback: function (data) {
      // console.log(data.val());
    }
  },
  fireSettings: {
    source: db.ref('laundryrooms/' + this.$laundryRoom + '/settings').orderByChild('start'),
    asObject: true,
    readyCallback: function (data) {
      // console.log(data.val());

    }
  },
  }
}, //end of firebase
  components: {
    'calendar': Calendar,
    'machine-selection': machineSelection,
    'booking-loader': bookingLoader,
    'reservation-modal': reservationModal,
    'delete-booking-modal': deleteBookingModal,
    'info-modal': infoModal
  },
  computed: {

  },
  closeReservationModal() {
  this.showReservationModal = false;
},
  methods: {
    addBooking() {
      this.showReservationModal = !this.showReservationModal
    },
    //Cookie Modal Start
    closeModalSetCookie() {
      this.setCookie('infoModal','hide',4)
      this.showModal = false

    },
    getCookie: function (cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    setCookie: function (cname,cvalue,exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires=" + d.toGMTString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    checkCookie: function(cookieName) {
      var cookieValue = this.getCookie(cookieName);
      if (cookieValue == "hide") {
        return false
      } else {
        return true
      }
    }
    //Cookie Modal end
  },
  mounted () {
    // this.showModal = this.checkCookie('infoModal')
  },
  created () {
    bus.$on('machine', data => {
      this.machineSelection = data
    })
    bus.$on('date', data => {
      var d = new Date()
      d.setFullYear(data.year, data.month, data.date)
      d.setHours(0)
      d.setMinutes(0)
      d.setSeconds(0)
      d.setMilliseconds(0)
      this.selectedDateRecived = d
    })
    bus.$on('closeModal', data => {
      this.showReservationModal = false
    })

    bus.$on('testDate', data => {
      this.computedSelectionDay = data
      // console.log('testDate!!!! ' + data.month);
    })
    bus.$on('closeDeleteModal', data => {
      this.showDeleteBookingModal = false
      // console.log('testDate!!!! ' + data.month);
    })
    bus.$on('showDeleteModal', data => {
      this.deleteBookingObject = data
      this.showDeleteBookingModal = true

      // console.log('testDate!!!! ' + data.month);
    })
  }
}




</script>

<style scoped>
* {
  box-sizing: border-box;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

button {
  background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
}

.addButton {
  /* box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.4); */
  box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.3);
  /* box-shadow: 3px 3px 2px 0px rgba(0, 0, 0, 0.3); */
  cursor: pointer;
  position: fixed;
  display: block;
  width: 45px;
  height: 45px;
  line-height: 45px;
  border-radius: 100px;
  bottom: 30px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  background-color: #00BAE0;
}

.iconClass {
  margin: 7px auto;
  color: white;
}

.tester2 {
  /* position: relative;
  background-color: orange; */
}

.headerWrap {
  background: linear-gradient(rgba(0, 186, 224, 1), rgba(0, 186, 224, 0.5));
  /* border-radius: 0px 0px 3px 3px; */
}



</style>



// WEBPACK FOOTER //
// src/components/landingBooking.vue